import { createAsyncThunk } from "@reduxjs/toolkit";
import { UploadKYCDoc } from "../../apis/uploadKYC";

export const UploadKYC = createAsyncThunk("uploadKYC", async () => {
  const response = await UploadKYCDoc();
  // console.warn("second action res-->", response);
});
